<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Generate Site Data Mart
</h1>

<div class="execution-time-div">
    <span>Execution Time:</span>
    <span style="margin-left: 15px">{{this.JobTimeElapsed}}</span>
</div>

<div *ngIf="true" class="execution-status-div">
    <span>Execution Status: </span>
    <span style="margin-left: 15px">{{this.ExportStatus}}</span>
</div>

<div mat-dialog-actions>
    <button mat-flat-button
            [disabled]="this.JobInProgress"
            style="margin-left: 10px; width: 225px;"
            color="primary"
            (click)="this.generatSiteETLMetadataClicked()">
        Generate Data Mart
    </button>

    <!--
    <button mat-flat-button
            [disabled]="!this.JobCompleted"
            style="margin-left: 10px; width: 150px;"
            color="secondary"
            (click)="this.downloadSiteETLMetadataClicked()">
        Download Metadata
    </button>
    -->
    <ng-container *ngIf="true">
        <a *ngIf="this.DownloadExportedDataUrl != null"
           href="{{this.DownloadExportedDataUrl}}"
           target="_blank"
           class="download-a">Download</a>

        <span *ngIf="this.DownloadExportedDataUrl == null"
              class="download-span">Download</span>
    </ng-container>

    <button mat-flat-button
            [disabled]="false"
            style="margin-left: 10px;"
            (click)="this.cancelClicked()">
        Close
    </button>
</div>
